const de = {
  general: {
    position: 'Position',
    updateSuccess: 'Aktualisierung erfolgreich!',
    editProfileImg: 'Profilbild bearbeiten',
    editCoverImg: 'Cover-Bild bearbeiten',
    register: 'Registrieren',
    login: 'Anmelden',
    date: 'Datum',
    export: 'Exportieren',
    or: 'oder',
    end: 'Ende',
    confirmEmail: 'E-Mail bestätigen',
    password: 'Kennwort',
    forgetPassword: 'Kennwort vergessen?',
    changePassword: 'Kennwort ändern',
    confirmPassword: 'Kennwort bestätigen',
    knownAs: 'Bekannt als',
    oldPassword: 'Altes Kennwort',
    newPassword: 'Neues Kennwort',
    minLength: 'Mindestlänge beträgt {n}',
    unmatched: '{col} stimmt nicht überein.',
    chooseAnotherAccount: 'Mit einem anderen Konto anmelden',
    confirmNewPassword: 'Neues Kennwort bestätigen',
    required: 'Feld erforderlich.',
    country: 'Land',
    new: 'NEU',
    username: 'Nutzername',
    category: 'Kategorie'
  },
  livetour: 'Ausstellungsraum',
  country: {
    JP: 'Japan',
    KR: 'Korea',
    HK: 'Hongkong und Macau',
    SG: 'Singapur',
    MY: 'Malaysia',
    TH: 'Thailand',
    VN: 'Vietnam',
    ID: 'Indonesien',
    PH: 'Philippinen',
    EU: 'Europa',
    NA: 'Nordamerika',
    NZ: 'Neuseeland und Australien',
    TW: 'Taiwan'
  },
  vrlounge: {
    ticketNotOnboardHint: 'Bitte betreten Sie die virtuelle Online-Ausstellung nach Einführung des Tickets bei der physischen Ausstellung.',
    cannotChangeAfterSubmit: 'Kann nach Einreichen nicht geändert werden',
    willReceiveEmail: 'Bitte beachten Sie, dass Sie später eine von iStaging, dem Anbieter der Online-Plattform der WEA2021, versendete E-Mail (mit dem Link zur Kennwortrücksetzung) erhalten.',
    hintLogin: 'Wenn Sie sich mit Ihrer Ticketnummer registriert haben, klicken Sie zur Anmeldung über Ihre E-Mail bitte auf „Anmelden“.',
    lounge: 'VR-Lounge',
    networking: 'Vernetzung',
    profile: 'Mein Profil',
    peopleOnline: 'Personen online',
    totalVisitors: 'Besucher gesamt',
    connect: 'Verbinden',
    waitConfirmed: 'Warten auf Bestätigung',
    isConfirmed: 'Bestätigt',
    confirm: 'bestätigen Sie',
    reject: 'ablehnen',
    confirmReject: 'Wirklich ablehnen?',
    hintReject: 'Dies kann nicht abgebrochen werden',
    thinkTwice: 'Lass mich zweimal überlegen',
    rejectInvitation: 'Einladung ablehnen',
    connectSuccess: 'Verbindung erfolgreich!',
    block: 'Blockieren',
    visitor: 'Besucher',
    exhibitor: 'Aussteller',
    invitationTitle: 'Personalisierte Einladungsnachricht',
    invitationPlaceholder: 'Hallo! Wir hoffen, mit Ihnen in Kontakt zu treten! (maximal 1000 Zeichen)',
    noTicketRecord: 'Keine Ticketaufzeichnung. Bitte erwerben Sie ein Ticket.',
    invalidTicket: 'Ungültiges Ticket',
    enterTicket: 'Bitte Ihre Ticketnummer eingeben',
    sent: 'Gesendet',
    received: 'Empfangen',
    connected: 'Verbunden',
    agreeToContinue: 'Sie müssen zum Fortfahren den allgemeinen Geschäftsbedingungen und der Datenschutzerklärung zustimmen.',
    ticketUsed: 'Dieses Ticket wurde verwendet.',
    passwordRule: 'Das Kennwort muss 8 Zeichen enthalten, darunter mindestens einen Buchstaben und eine Ziffer.',
    cardExchange: 'Der Besucher möchte Visitenkarten mit Ihnen tauschen. Bitte bestätigen Sie, ob Sie den Tausch annehmen oder ablehnen.',
    loginToAccount: 'An Ihrem Konto anmelden',
    keepLogin: 'Angemeldet bleiben',
    cantLogin: 'Anmeldung nicht möglich? Hier klicken',
    here: 'hier',
    allRole: 'alle Rollen',
    sortNameAtoZ: 'Name (A→Z)',
    sortNameZtoA: 'Name (Z→A)',
    onlineNewToOld: 'Letzte Anmeldezeit (Neueste)',
    onlineOldToNew: 'Letzte Anmeldezeit (früheste)',
    exhibitorFirst: 'Aussteller zuerst',
    visitorFirst: 'Besucher zuerst',
    inviteTimeNewToOld: 'Einladungszeit (neueste)',
    inviteTimeOldToNew: 'Einladungszeit (am frühesten)',
    basicInfo: 'Basisinformation',
    contact: 'Kontakt',
    state: 'Zustand',
    sentRequest: 'Anfrage senden',
    haveNotConfirmed: 'Sie haben noch nicht bestätigt',
    message: 'Die Nachricht',
    sendMessageTo: 'Nachricht senden an'
  },
  sort: 'Sortieren',
  filter: 'Filter',
  test: 'Test',
  apply: 'Übernehmen',
  all: 'Alle',
  livingroom: 'Wohnzimmer',
  diningroom: 'Esszimmer',
  kitchen: 'Küche',
  bedroom: 'Schlafzimmer',
  study: 'Studienzimmer',
  bathroom: 'Badezimmer',
  toilet: 'Toilette',
  garden: 'Garten',
  garage: 'Garage',
  outdoors: 'Im Freien',
  others: 'Sonstiges',
  vrTooltip: 'VR-Modus ist nur bei Mobilgeräten verfügbar',
  vrInstructions: 'Bitte platzieren Sie das <strong>Telefon</strong> in einem <strong>VR-Headset</strong>.',
  send: 'Senden',
  scanQrCode: 'Scannen Sie den QR-Code zur Anzeige der virtuellen Tour an Ihrem Telefon.',
  logOut: 'Abmelden',
  postAsAnonymous: 'Nein, danke, ich poste anonym.',
  loginGoogle: 'Mit Google+ anmelden',
  loginFacebook: 'Mit Facebook anmelden',
  postComment: 'Einen Kommentar hinterlassen',
  selectAction: 'Bitte auswählen',
  noBuilding: 'Entschuldigung, diese LiveTour existiert nicht.',
  browserNoSupport: '<h3>Entschuldigung, Ihr Browser wird nicht unterstützt.</h3><p>Bitte laden Sie einen anderen Browser herunter und installieren Sie diesen, z. B.<a href="https://www.google.com/chrome/browser/desktop">Chrome</a>,<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">IE11</a> oder<a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>.</p>',
  webGlNoSupport: '<h3>Abrufen des WebGL-Kontexts fehlgeschlagen. Ihr Browser oder Gerät unterstützt WebGL möglicherweise nicht.</h3>',
  urlNoSupportIFrameError: 'Dieser Link ist abgelaufen oder die Seite nimmt keine externen eingebetteten Links an.',
  noPanoramas: 'Ups! Das Panorama existiert nicht.',
  buildingNotFound: '<h3>Ups! Der Link existiert nicht. </h3><p> Die LiveTour kann nicht gefunden werden.</p><a href="https://www.istaging.com/en/livetour-gallery">Siehe andere LiveTours</a>',
  weaBuildingNotFound: '<h3>In Kürze verfügbar.</h3><p>Die virtuelle WEA2021 beginnt um 10:00 Uhr am 10. März 2021.</p>',
  buildingNotInPropertyRedirect: '<h3>Ups! Die LiveTour wurde entfernt.</h3><p>Sie werden zur ersten LiveTour Ihrer Liste weitergeleitet ...</p>.',
  information: 'Informationen',
  panoSelect: 'Panoramas',
  floorplan: 'Grundriss',
  qrCode: 'QR-Code',
  music: 'Musik',
  gyro: 'Gyro',
  vrmode: 'VR-Modus',
  fullscreen: 'Vollbild',
  like: 'Like',
  comment: 'Kommentar',
  propertyInfo: 'Gruppeninformationen',
  buildingInfo: 'LiveTour-Info',
  buyNow: 'Jetzt kaufen',
  viewAtHome: 'In AR anzeigen',
  learnMore: 'Mehr erfahren',
  contactSupplier: 'Anbieter kontaktieren',
  memo: 'Memo',
  location: 'Standort',
  promotionText: 'Virtuelle Touren leicht gemacht >',
  promotionLinkText: 'Beginnen bei 5 $',
  close: 'Schließen',
  addComment: 'Kommentar zufügen',
  share: 'Teilen',
  leaveInfoContinue: 'Bitte Ihre Informationen zur Anzeige dieser LiveTour eingeben',
  company: 'Unternehmen',
  companyName: 'Unternehmensname',
  name: 'Name',
  firstName: 'Vorname',
  lastName: 'Nachname',
  email: 'E-Mail',
  phone: 'Telefon',
  occupation: 'Beruf',
  emailFormatInvalid: 'Ungültiges E-Mail-Format.',
  duplicateEmail: 'Doppelte E-Mail',
  privacyPolicy: 'Datenschutzerklärung',
  userTerms: 'Allgemeine Geschäftsbedingungen',
  visitorLogin: 'Sie haben ein Konto?',
  visitorAgreement1: 'ihre Privatsphäre ist uns wichtig. Durch Übermittlung Ihrer Informationen stimmen Sie {company}s {privacyTag} und {termsTag} zu.',
  visitorAgreement2: 'Sie berechtigen {company}, Sie telefonisch, per E-Mail, Textmitteilung oder Post über Produkte und Dienstleistungen von {company} zu informieren. Sie können diese Berechtigung widerrufen, indem Sie uns unter {email} kontaktieren.',
  visitorAgreement: 'Ich stimmt den <a href="https://www.istaging.com/en/terms" target="_blank">Nutzungsbedingungen </a> und der <a href="https://www.istaging.com/en/privacy" target="_blank">Datenschutzerklärung</a> zu.',
  visitorLeaveDataReason: 'Willkommen zu diesem virtuellen Erlebnis! Sobald Sie Ihre Kontaktinformationen einreichen, erhalten Sie einen Verifizierungslink per E-Mail, sodass Sie beitreten können.',
  visitorAgreePolicy: 'Ich stimme zu, dass der Inhaber dieses virtuellen Erlebnisses mich per E-Mail oder Telefon kontaktieren darf.',
  visitorEnterAccessKey: 'Bitte geben Sie den per E-Mail erhaltenen Zugangscode ein. Wenn Sie ihn nicht erhalten haben, werfen Sie einen Blick in Ihren Spam-Ordner.',
  accessCode: 'Zugangscode',
  accessCodeError: 'Zugangscode-Fehler',
  receiveEmailVerification: 'Bitte entnehmen Sie Ihren Zugangscode Ihrem E-Mail-Postfach.',
  verify: 'Verifizieren',
  back: 'Zurück',
  welcomeToLiveTour: 'Willkommen zur <strong>LiveTour</strong>',
  resend: 'Erneut senden',
  invalidAccessCode: 'Zugangscode ist ungültig',
  resendCodeError: 'Erneutes Senden des Zugangscodes fehlgeschlagen',
  website: 'Website',
  cardMore: 'Mehr',
  clickNavigate: 'Navigieren',
  showMore: 'Mehr anzeigen',
  searchTag: 'Tag suchen',
  somethingWrong: '<h3>Ups ... Etwas ist schiefgelaufen ...</h3><a href="https://www.istaging.com/en/contact">Dieses unbekannte Problem melden</a>',
  GuidedTour: 'Geleitete Tour',
  ClientWelcome: 'Willkommen',
  ClientFormHint: 'Durch Anklicken von „Jetzt anrufen“ stimme ich den <a href="https://www.istaging.com/en/terms" target="_blank" class="link-yellow">Servicebedingungen</a> und der <a class="link-yellow" href="https://www.istaging.com/en/privacy" target="_blank">Datenschutzerklärung</a> zu und der Vertreter kann mich per Telefon kontaktieren',
  ClientFormWelcomeText: 'Füllen Sie die folgenden Informationen aus und klicken Sie auf „Jetzt anrufen“.<br>Sie werden online von einem Vertreter angeleitet.<br>Verbinden Sie Ihr Headset und Mikrofon und achten Sie darauf, dass Sie für ein besseres Erlebnis eine gute Netzwerkverbindung haben.',
  ClientWelcomeNamePhoneHint: 'Ihren Namen und Ihre Telefonnummer eingeben',
  ClientWelcomeNameHint: 'Ihren Namen eingeben',
  ClientWelcomePhoneHint: 'Ihre Telefonnummer eingeben oder das Format ist falsch',
  ClientWelcomeLanguage: 'Sprache',
  ClientWelcomeLanguageDesc: 'Bitte wählen Sie die Sprache des Tour Guide.',
  ClientWelcomeLanguageHint: 'Bitte eine Sprache wählen',
  FieldRequired: '* erforderlich',
  ClientFormCallNow: 'Jetzt anrufen',
  None: '/',
  Agent: 'Agent',
  RememberMe: 'Anmeldedaten speichern',
  TheFieldIsRequired: '*erforderliches Feld',
  IncorrectFormat: 'Falsches Format',
  YouMustAgreeLicense: 'Sie müssen den oben erwähnten Bedingungen zustimmen.',
  Submit: 'Absenden',
  BuildingNonPublicInfo: 'Diese LiveTour wird von der Ansicht ausgeblendet.',
  WebRTCNotSupportTitle: 'Browser wird nicht unterstützt',
  WebRTCNotSupportDesc: 'Seiten-URL kopieren und in Google Chrome, Firefox oder Safari einfügen',
  WebRTCNotSupportDesciOS: 'Seiten-URL kopieren und in Safari einfügen',
  WebRTCNotSupportDescAndroid: 'Seiten-URL kopieren und in Chrome oder Firefox einfügen',
  WebRTCNotSupportCopyButton: 'Ein-Klick-Kopie',
  Copied: 'Kopie abgeschlossen',
  search: 'Suchen',
  searchContent: 'Inhalt suchen',
  noResult: 'Keine Ergebnisse gefunden',
  searchResult: 'Suchergebnis',
  relatedResult: 'Relevantes Ergebnis',
  scaleUp: 'Nach oben skalieren',
  scaleDown: 'Nach unten skalieren',
  viewIn3D: 'In 3D ansehen',
  unableJoinMeeting: 'Beitreten des Meetings nicht möglich',
  invalidMeetingId: 'Ungültige Meeting-Kennung',
  unableAccessMediaDevice: 'Ihr Browser verhindert Zugriff auf Ihr(e) Kamera / Mikrofon. Bitte prüfen Sie die Medien-Berechtigungseinstellungen des Browsers.',
  connectingMeeting: 'Sie sind dabei, ein Meeting zu veranstalten',
  meetingNotStartedYet: 'Beitreten zum Meeting nicht möglich. Es hat noch nicht begonnen.',
  joinedMeeting: 'Sie befinden sich im Meeting',
  joiningMeeting: 'Sie sind dabei, einem Meeting beizutreten',
  repeatJoinWarning: 'Wenn Sie erneut beitreten, wird die ursprünglich verbundene Seite getrennt.',
  meetingIsOver: 'Meeting ist vorüber.',
  startAnotherMeeting: 'Bitte besuchen Sie den Editor zum Starten eines weiteren Meetings.',
  closeMeeting: 'Schließen',
  joinMeeting: 'Meeting beitreten',
  leaveMeeting: 'Verlassen',
  remainTime: 'Restzeit',
  meetingIsFull: 'Ihr Meeting ist voll',
  connectionFail: 'Verbindung fehlgeschlagen',
  unableConnectMeeting: 'Beitreten des Meetings nicht möglich',
  joinMeetingFail: 'Beitreten zum Meeting fehlgeschlagen',
  aboutEndMeeting: 'Sie sind dabei, dieses Meeting zu beenden',
  aboutLeaveMeeting: 'Sie sind dabei, dieses Meeting zu verlassen',
  endedMeeting: 'Dieses Meeting hat geendet',
  meetingRedirect: 'Wir leiten Sie zu LiveTour weiter.',
  leftMeeting: 'Sie haben dieses Meeting verlassen',
  waitMeeting: 'Der Veranstalter hat sich vorübergehend entfernt. Das Meeting wird nach Wiederverbindung des Veranstalters fortgesetzt. Wenn der Veranstalter sich nicht innerhalb von 5 Minuten wieder verbindet, endet das Meeting',
  copyLink: 'Link kopieren',
  copySuccess: 'Erfolgreich kopiert',
  confirm: 'OK',
  cancel: 'Abbrechen',
  product: 'Produkt',
  pilot: 'Pilot',
  pilotStop: 'Steuerung stoppen',
  pilotTours: 'Touren',
  pilotPopularTours: 'Beliebte Touren',
  pilotInfluencerList: 'Tour-Guide-Liste',
  pilotTourBy: 'Tour nach {influencer}',
  PilotDescription: 'Beschreibung',
  PilotDetailedInformation: 'Detaillierte Informationen',
  pilotSwitchTourNotice: 'Sie geben aktuell „{pilot1}“ wieder.<br>Möchten Sie „{pilot2}“ wirklich starten?',
  pilotSameTourNotice: 'Sie geben aktuell „{pilot1}“ wieder.<br>Möchten Sie von vorne beginnen?',
  pilotPlayerPopupButtonYes: 'Ja',
  pilotRecorderStart: 'Zum Starten hier klicken',
  pilotRecorderStop: 'Zum Stoppen hier klicken',
  pilotRecorderUploading: 'Wird hochgeladen ...',
  pilotRecorderUploadFailed: 'Upload fehlgeschlagen.',
  pilotRecorderPopupTitleNotice: 'Hinweis',
  pilotRecorderPopupTitleComplete: 'Aufzeichnung abgeschlossen',
  pilotRecorderPopupTitleError: 'Fehler',
  pilotRecorderPopupTextNotice: '• Die Aufzeichnungszeit ist auf 10 Minuten beschränkt.<br>• Bitte erlauben Sie dem System Zugriff auf Ihr Mikrofon.',
  pilotRecorderPopupTextComplete: 'Ihr Kapitel ist abgeschlossen.<br>Bitte prüfen Sie es im VR-Editor.',
  pilotRecorderPopupTextRelogin: 'Erneute Anmeldung erforderlich.',
  pilotRecorderPopupTextError: 'Bitte prüfen Sie die Mikrofon-Berechtigung in Ihrem Browser.',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: 'Die 10-minütige Aufzeichnungszeit endet in Kürze. Bitte schließen Sie Ihre Aufzeichnung ab.',
  pilotTooltipTitle: 'Erinnerung, Sie können hier klicken, um weitere geführte Routen anzuzeigen.',
  pilotTooltipConfirm: 'Verstehe! Lasst uns beginnen',
  pilotTooltipCancel: 'Tour überspringen',
  selectPilot: 'Pilot auswählen',
  pilotInfluencer: 'Piloten-Influencer',
  pilotChaptersTitle: 'Routenkapitel (zum Anhören auswählen)',
  pilotReadMoreBtnLabel: 'Vollständigen Inhalt anzeigen',
  pilotSelfBrowsingModeMessageTitle: 'Wechseln Sie in den Self-Browsing-Modus',
  pilotSelfBrowsingModeMessageContent: 'Sie können jederzeit in den Tourmodus zurückkehren, indem Sie auf die Einschalttaste klicken.',
  pilotReplay: 'Wiederholung',
  pilotPrevious: 'Zurück',
  pilotNext: 'Weiter',
  pilotPause: 'Pause',
  pilotPlay: 'Spielen',
  pilotTurnOnSelfBrowsingMode: 'Tourmodus ausschalten',
  pilotTurnOffSelfBrowsingMode: 'Schalten Sie den Tourmodus ein',
  conferenceDisconnect: 'Schlechte Internetverbindung. Bitte Ihre Verbindung prüfen.',
  conferenceMute: 'Stumm ein',
  conferenceUnmute: 'Stumm aus',
  conferenceStopVideo: 'Video stoppen',
  conferenceVideo: 'Video',
  conferenceShare: 'Teilen',
  conferenceChat: 'Chat',
  conferenceParticipant: 'Teilnehmer',
  conferenceAudience: 'Publikum',
  conferenceMore: 'Mehr',
  conferenceCopyLink: 'Meeting-Link kopieren',
  conferenceCameraAndMicrophone: 'Kamera und Mikrofon',
  conferenceHost: 'Veranstalter',
  conferencePresenter: 'Präsentator',
  conferenceExpel: 'Löschen',
  conferenceChangeRole: 'Rolle ändern in',
  conferenceTypeMessage: 'Hier Ihre Mitteilung eingeben',
  conferenceEveryone: 'Jeder',
  conferenceLoginError: 'Es gab einen Fehler bei der Anmeldung am Kanal, bitte erneut versuchen',
  conferenceJoinError: 'Beim Aufrufen des Kanals ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceLeaveError: 'Beim Verlassen des Kanals ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceGetMemberCountError: 'Beim Abrufen der Anzahl Kanalmitglieder ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceSendMessageError: 'Beim Senden der Mitteilung gab es einen Fehler, bitte erneut versuchen',
  conferenceSendInfoError: 'Beim Posten der Neuigkeiten ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceGetMemberError: 'Beim Abrufen der Kanalmitglieder gab es einen Fehler, bitte erneut versuchen',
  conferenceChangeRoleError: 'Beim Einrichten der Rolle ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferencePublishError: 'Beim Veröffentlichen des Videos ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceCancelPublishError: 'Beim Zurückziehen der Veröffentlichung des Videos ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceGetMemberInfoError: 'Beim Abrufen von Mitgliederinformationen ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceSetMediatError: 'Beim Anpassen des Videos ist ein Fehler aufgetreten, bitte erneut versuchen',
  conferenceToLeave: 'Möchten Sie das Meeting verlassen',
  conferenceToExpel: 'Möchten Sie %{name} aus diesem Meeting entfernen',
  conferenceChangeRoleFail: 'Rollenänderung fehlgeschlagen',
  conferenceGetChangeRole: 'Sie sind nun %{role} dieses Meetings',
  conferenceGetCameraClosed: 'Video durch Veranstalter gestoppt',
  conferenceGetUnmuted: 'Stummschaltung durch Veranstalter deaktiviert',
  conferenceGetMuted: 'Stummschaltung durch Veranstalter aktiviert',
  conferenceCopyLinkSuccess: 'Meeting-Link kopiert',
  conferenceGetExpeled: 'Der Veranstalter hat Sie aus dem Meeting entfernt.',
  conferenceBrowserNotSupported: 'Ihr Browser wird nicht unterstützt. Rüsten Sie auf die neueste Version von Chrome, Safari oder Edge auf.',
  conferenceNotStart: 'Das Meeting hat noch nicht begonnen',
  conferenceEnd: 'Das Meeting wurde abgeschlossen',
  conferenceTimeup: 'Die Meeting-Zeit ist abgelaufen',
  conferenceMicrophone: 'Mikrofon',
  conferenceSoundLevel: 'Geräuschpegel',
  conferenceVolume: 'Lautstärke',
  conferenceCamera: 'Kamera',
  conferenceDetectAudioFail: 'Erkennung von Tongerät nicht möglich',
  conferenceDetectVideoFail: 'Erkennung von Videogerät nicht möglich',
  conferenceShareNotAvailable: 'Dieser Browser unterstützt keine Freigabe. Nutzen Sie zur Inhaltsfreigabe die aktuellste Version von Chrome, Edge oder Firefox.',
  conferenceScreenNotAvailable: 'Andere Präsentatoren teilen den Bildschirm',
  booking: {
    calendar: 'Kalender',
    reserve: 'Reservieren',
    dateSelectTitle: 'Wählen Sie eine Zeit, die für Sie funktioniert.',
    backToSelect: 'Eine andere Zeit wählen',
    requiredField: 'Dies ist ein Pflichtfeld',
    timeRange: 'Zeitbereich',
    fieldMessage: 'Mitteilung',
    confirm: 'Buchung bestätigen',
    pleaseWait: 'Bitte warten ...',
    submitError: 'Während des Versands der Anfrage ist ein Fehler aufgetreten.',
    reserveSuccess: 'Buchung erfolgreich',
    thanksUser: 'Danke.',
    confirmingEmail: 'Sie erhalten in Kürze eine Benachrichtigung zur Bestätigung der Meeting-Details.',
    emailEmptyHint: 'E-Mail ist leer.'
  },
  favorites: {
    title: 'Favoriten',
    add: 'Den Favoriten zufügen',
    remove: 'Aus Favoriten entfernen',
    category: {
      marker: 'Produkt',
      panorama: 'Ausstellungsraum',
      company: 'Unternehmen',
      card: 'Visitenkarte'
    },
    table: {
      image: {
        company: 'Logo',
        marker: 'Produktbild',
        card: 'Avatar'
      },
      name: {
        company: 'Unternehmensname',
        marker: 'Produktname',
        card: 'Name'
      },
      description: {
        company: 'Unternehmensbeschreibung',
        marker: 'Produktbeschreibung'
      },
      type: 'Typ',
      note: 'Hinweis',
      company: 'Unternehmen',
      occupation: 'Beruf',
      listEmpty: 'Noch nicht'
    },
    note: {
      empty: 'Einen Hinweis eingeben ... (bis zu {n} Buchstaben)',
      saved: 'Gespeichert!'
    },
    pdf: {
      export: 'Als PDF exportieren',
      exporting: 'Wird exportiert ...',
      note: 'Hinweis:',
      pager: 'Seite {page} von {total}'
    }
  },
  introAssets: {
    enter: 'Eingeben'
  },
  whiteList: {
    warnTitle: 'AUTHENTIFIZIERUNG FEHLGESCHLAGEN',
    warnContent: 'IHR NUTZERNAME EXISTIERT IN DER AUTORISIERTEN LISTE NICHT, BITTE ERNEUT VERSUCHEN ODER ADMINISTRATOR KONTAKTIEREN.'
  },
  instantMessaging: {
    quickQA: 'Schnelle Fragen und Antworten',
    mediaMessage: 'Eine Datei freigegeben',
    locationMessage: 'Eine Datei freigegeben',
    startConversation: 'Starten Sie ein Gespräch mit dem Organisator in dieser Ausstellungsfläche!'
  },
  noSearchResult: 'Keine Daten gefunden. Bitte die Anfragebedingungen ändern und erneut suchen',
  tourring: {
    host: 'Gastgeber',
    noAnswer: 'Ihr Kontakt kann aktuell nicht antworten.',
    noPushId: 'Ihr Kontakt ist aktuell nicht verfügbar.',
    busy: 'Ihr Kontakt ist mit einer geleiteten Tour beschäftigt.',
    response: 'Bitte beachten Sie den Reservierungskalender.',
    goToReserve: 'Auf den Kalender zugreifen',
    dialing: 'Wählen',
    dialingHint: 'Nachdem Sie eine Verbindung hergestellt haben, öffnet sich ein neues Register',
    handupPhoneHint: 'Ihr Anruf ist noch nicht verbunden,',
    handupPhoneHint2: 'Bitte bestätigen Sie, ob aufgelegt werden soll.'
  },
  visitorCheckTheEmail: 'Fast geschafft!<br>Lassen Sie uns Ihre E-Mail-Adresse bestätigen. Rufen Sie Ihren Posteingang auf und verifizieren Sie Ihre E-Mail durch Anklicken des von Ihnen erhaltenen Links.<br>Nun sind Sie nur noch einen Schritt davon entfernt, auf Ihr virtuelles Erlebnis zuzugreifen!',
  video360: {
    notAvailable: 'Das Video ist in Ihrem Land nicht verfügbar.'
  },
  utils: {
    more: 'Mehr anzeigen',
    less: 'Weniger anzeigen'
  },
  productUnavailable: 'Dieser Artikel ist nicht mehr verfügbar'
}

export default de
